module.exports = __webpack_public_path__ + "static/media/img4.87f626e0.jpg";